export const hexToRgb = (hex: string) => {
  const regex = /^#([A-Fa-f0-9]{3}){1,2}$/;

  if (!regex.test(hex)) {
    throw new Error('Invalid hex color');
  }

  const hexValues = hex.substring(1).split('');

  if (hexValues.length === 3) {
    hexValues.push('F');
  }

  const [r1, r2, g1, g2, b1, b2] = hexValues;
  const r = parseInt(`${r1}${r2}`, 16);
  const g = parseInt(`${g1}${g2}`, 16);
  const b = parseInt(`${b1}${b2}`, 16);

  return `${r}, ${g}, ${b}`;
};
